import { render, staticRenderFns } from "./PropertyListForm.vue?vue&type=template&id=e580f228&"
import script from "./PropertyListForm.vue?vue&type=script&lang=js&"
export * from "./PropertyListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports